import mobiusVersionsJson from "@/assets/mobius-versions.json";
import type { DropdownOption } from "@comp-lib/components/CustomDropdown.vue";

// MobiusVersion type: matches the format "vN.N" or "vNN.NN"
// Examples: "v2.1", "v3.0", "v10.12"
export type MobiusVersion = `v${number}.${number}`;

export const mobiusVersions: MobiusVersion[] = mobiusVersionsJson.availableMobiusVersions as MobiusVersion[];
export const currentDefaultVersion: MobiusVersion = mobiusVersionsJson.currentDefaultVersion as MobiusVersion;
export const currentVersionReleaseDate: string = mobiusVersionsJson.currentVersionReleaseDate;

// Dropdown options for CustomDropdown.vue
export function getMobiusVersionOptions(): DropdownOption[] {
  return mobiusVersions.map(version => ({
    label: version,
    value: version
  }));
}
